'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'

import SignUpButton from '../../../components/SignUpButton/SignUpButton'
import ConvertButton from '../../../components/ConvertButton/ConvertButton'

const Banner = () => {
  const translate = useTranslate('business.homepage')
  const { user } = useSession()
  const isUserLoggedIn = !!user

  return (
    <div className="u-ui-padding-top-large">
      <div className="business-accounts-homepage__banner tear tear--top">
        <div className="business-accounts-homepage__banner-heading">
          <div className="u-text-center">
            <Text as="span" alignment={Text.Alignment.Center} width={Text.Width.Parent}>
              <span className="c-text--responsive-large-heading c-text--inverse">
                {translate('banner.title')}
              </span>
            </Text>
            <Spacer size={Spacer.Size.XLarge} />
            <div className="business-accounts-homepage__cta">
              {isUserLoggedIn ? (
                <ConvertButton text={translate('actions.convert_to_vinted_pro')} inverse />
              ) : (
                <SignUpButton text={translate('actions.sign_up_for_vinted_pro')} inverse />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Banner
